<ng-template #nodoOpciones let-opciones="opciones" let-nivel="nivel">
  @for (opcion of opciones; track opcion.identificador) {
    @if (opcion.hijos?.length) {
      <button
        type="button"
        class="eq-menu-lateral__item eq-menu-lateral__item--boton"
        [class.eq-menu-lateral__item--padre-activo]="tieneHijoActivo(opcion)"
        [attr.aria-expanded]="estaExpandido(opcion.identificador)"
        [style.padding-left]="'calc(var(--eq-padding-8) + ' + nivel * sangriaPorNivel + 'px)'"
        (click)="alternarGrupo(opcion.identificador)"
      >
        <i [class]="opcion.icono + ' eq-menu-lateral__item-icono'"></i>
        <span class="eq-menu-lateral__item-etiqueta">{{ opcion.etiqueta }}</span>
        <i
          class="pi pi-chevron-down eq-menu-lateral__item-chevron"
          [class.eq-menu-lateral__item-chevron--expandido]="estaExpandido(opcion.identificador)"
        ></i>
      </button>
      @if (estaExpandido(opcion.identificador)) {
        <div class="eq-menu-lateral__submenu">
          <ng-container
            *ngTemplateOutlet="nodoOpciones; context: { opciones: opcion.hijos, nivel: nivel + 1 }"
          />
        </div>
      }
    } @else if (opcion.urlExterna) {
      <a
        class="eq-menu-lateral__item"
        [href]="opcion.urlExterna"
        target="_blank"
        rel="noopener noreferrer"
        [style.padding-left]="'calc(var(--eq-padding-8) + ' + nivel * sangriaPorNivel + 'px)'"
        (click)="cerrarMenuMovil()"
      >
        <i [class]="opcion.icono + ' eq-menu-lateral__item-icono'"></i>
        <span class="eq-menu-lateral__item-etiqueta">{{ opcion.etiqueta }}</span>
        <i class="pi pi-external-link eq-menu-lateral__item-chevron-flecha"></i>
      </a>
    } @else {
      <a
        class="eq-menu-lateral__item"
        [routerLink]="opcion.ruta"
        routerLinkActive="eq-menu-lateral__item--activo"
        [routerLinkActiveOptions]="{ exact: true }"
        [style.padding-left]="'calc(var(--eq-padding-8) + ' + nivel * sangriaPorNivel + 'px)'"
        (click)="cerrarMenuMovil()"
      >
        <i [class]="opcion.icono + ' eq-menu-lateral__item-icono'"></i>
        <span class="eq-menu-lateral__item-etiqueta">{{ opcion.etiqueta }}</span>
        <i class="pi pi-chevron-right eq-menu-lateral__item-chevron-flecha"></i>
      </a>
    }
  }
</ng-template>

<ng-template #listaSecciones>
  @if (cargandoMenu()) {
    <div class="eq-menu-lateral__estado">
      <div class="eq-cargando eq-cargando--2" role="status">
        <p-progress-spinner strokeWidth="4" />
        <span class="eq-cargando__texto">{{ t().menuLateral.cargando }}</span>
      </div>
    </div>
  } @else if (errorMenu()) {
    <div class="eq-menu-lateral__estado">
      <span>{{ t().menuLateral.errorCarga }}</span>
      <p-button
        [label]="t().menuLateral.reintentar"
        icon="pi pi-refresh"
        [outlined]="true"
        (onClick)="reintentarCargaMenu()"
      />
    </div>
  }
  @for (seccion of secciones(); track seccion.identificador) {
    <div class="eq-menu-lateral__seccion">
      <div class="eq-menu-lateral__app-titulo">{{ seccion.titulo }}</div>
      <ng-container
        *ngTemplateOutlet="nodoOpciones; context: { opciones: seccion.opciones, nivel: 0 }"
      />
    </div>
  }
</ng-template>

<!-- Sidebar fijo (>768px) -->
<nav class="eq-menu-lateral" [attr.aria-label]="t().menuLateral.menuPrincipal">
  <ng-container [ngTemplateOutlet]="listaSecciones" />
</nav>

<!-- Drawer de navegación (≤768px), se abre desde el botón hamburguesa de la barra superior -->
@if (menuMovilAbierto()) {
  <p-drawer
    [visible]="menuMovilAbierto()"
    (visibleChange)="alCambiarVisibilidadDrawer($event)"
    position="left"
    [header]="t().menuLateral.menu"
    [modal]="true"
    [style]="estiloDrawer"
  >
    <ng-container [ngTemplateOutlet]="listaSecciones" />
  </p-drawer>
}
